// extracted by mini-css-extract-plugin
export default {"progressBar":"ASLVideoUploadWaitModal_progressBar__WBHPs"};